import { FrownOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { clearAppCacheAndReload } from '../../utils/clearApp';
import { SentryCaptureException } from '@/utils/sentry';
import { ErrorContainer, ErrorDescription, ErrorMessage } from './styles';

interface GlobalErrorBoundaryState {
    hasError: boolean;
}

class GlobalErrorBoundary extends React.Component<
    React.PropsWithChildren<{}>,
    GlobalErrorBoundaryState
> {
    constructor(props: React.PropsWithChildren<{}>) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        if (
            error.message.includes('Rendered fewer hooks')
        ) {
            return null;
        }
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        SentryCaptureException(error);
    }

    handleGoHome = () => {
        clearAppCacheAndReload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <ErrorContainer>
                    <FrownOutlined
                        style={{
                            fontSize: 64,
                            color: '#ff4d4f',
                            marginBottom: 16,
                        }}
                    />
                    <ErrorMessage>Ops! Algo deu errado.</ErrorMessage>
                    <ErrorDescription>
                        Não se preocupe! Vamos tentar corrigir isso. Por favor,
                        volte ao início.
                    </ErrorDescription>
                    <Button
                        type="primary"
                        onClick={this.handleGoHome}
                        style={{ marginTop: 20 }}
                    >
                        Voltar ao Início
                    </Button>
                </ErrorContainer>
            );
        }

        return this.props.children;
    }
}

export default GlobalErrorBoundary;
